//@flow
import { call, put, takeLatest, select, all } from "redux-saga/effects";
import {
  GET_CAMPAIGN_RESOURCES_REQUESTING,
  GET_CAMPAIGN_RESOURCES_SUCCESS,
  GET_CAMPAIGN_RESOURCES_ERROR,
  VISIT_CAMPAIGN_RESOURCE_REQUESTING,
  SEND_CAMPAIGN_RESOURCE_FEEDBACK_REQUESTING,
  SEND_CAMPAIGN_RESOURCE_FEEDBACK_SUCCESS,
  SEND_CAMPAIGN_RESOURCE_FEEDBACK_ERROR,
} from "./constants";
import { fetchApi } from "../api";

import { visitResourceFlow } from "../coaching/sagas";

const endPoints = {
  sendCampaignResourceFeedback: "/v1/resources/campaign/feedback",
  getCampaignResources: "/v1/resources/campaign",
  visitCampaignResource: "/v1/resources/campaign/visit",
};

const getCampaignResourcesApi = data => {
  const { campaignId, userId } = data;

  return fetchApi(
    `${endPoints.getCampaignResources}?campaignId=${campaignId}&userId=${userId}`,
    {},
    "get",
  );
};

const sendResourceFeedbackApi = data => {
  return fetchApi(`${endPoints.sendCampaignResourceFeedback}`, data, "post");
};
/*
const visitCampaignResourceApi = data => {
  return fetchApi(`${endPoints.submitAnswers}`, data, "post");
};*/
// retirer la fonction

function* getCampaignResourcesFlow(action) {
  try {
    const response = yield call(getCampaignResourcesApi, action.payload);

    yield put({ type: GET_CAMPAIGN_RESOURCES_SUCCESS, payload: response });
  } catch (error) {
    console.log(error);
    yield put({ type: GET_CAMPAIGN_RESOURCES_ERROR, error: error.message });
  }
}

function* sendResourceFeedbackFlow(action) {
  try {
    const response = yield call(sendResourceFeedbackApi, action.payload);

    yield put({
      type: SEND_CAMPAIGN_RESOURCE_FEEDBACK_SUCCESS,
      payload: response,
    });
  } catch (e) {
    console.log(e);
    yield put({
      type: SEND_CAMPAIGN_RESOURCE_FEEDBACK_ERROR,
      error: e.message,
    });
  }
}

function* visitCampaignResourceFlow(action) {
  try {
    // const response = yield call(visitCampaignResourceApi, action.payload);

    yield visitResourceFlow(action);

    // yield put({ type: VISIT_RESOURCE_SUCCESS, payload: response });
  } catch (error) {
    console.log(error);
    // yield put({ type: VISIT_RESOURCE_ERROR, payload: error });
  }
}

function* watcher() {
  yield all([
    takeLatest(
      SEND_CAMPAIGN_RESOURCE_FEEDBACK_REQUESTING,
      sendResourceFeedbackFlow,
    ),
    takeLatest(GET_CAMPAIGN_RESOURCES_REQUESTING, getCampaignResourcesFlow),
    takeLatest(VISIT_CAMPAIGN_RESOURCE_REQUESTING, visitCampaignResourceFlow),
  ]);
}

export default watcher;
